module.exports = __webpack_public_path__ + "assets/RetinaNarr-Light.a01f232b940de2cb0291e9a80b446934.woff";